import { StoreOption } from "./store-option";
import { FindStoreNamesResponseDto } from "../../../core/stores/dtos/find-store-names.response.dto";

export class StoreOptionMapper {
  static toModel(data: FindStoreNamesResponseDto): StoreOption[] {
    return data.map(
      (v: any): StoreOption => ({
        ...v,
        value: v.id,
        label: v.name,
      })
    );
  }
}
